import React from "react";
import { Card, Col, Row } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { InstanceStatusMessage } from "./InstanceStatusMessage";
import { InstanceStatus } from "./types";
import { radius } from "@libertify/ui";

interface ProjectStatusCardProps {
  mediaStatus?: InstanceStatus;
  isLive: boolean;
}

export const ProjectStatusCard: React.FC<ProjectStatusCardProps> = ({
  mediaStatus,
  isLive,
}) => {
  const { theme } = useAntTheme();

  return (
    <Card
      style={{
        borderRadius: radius.box,
        border: theme.cardBorder,
        backgroundColor: theme.colorCardRedesign,
        boxShadow: theme.cardBoxShadow,
        width: "100%",
      }}
    >
      <Row
        align={"middle"}
        style={{
          borderRadius: radius.box,
          border: theme.cardBorder,
          background: theme.colorBgLayout,
          padding: "25px 15px",
        }}
      >
        <Col span={24}>
          <InstanceStatusMessage status={mediaStatus} isLive={isLive} />
        </Col>
      </Row>
    </Card>
  );
};
